var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-group form-group--read-only" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { class: `col-sm-${_vm.component.size}` }, [
        !_vm.component.hideLabel
          ? _c("label", [_vm._v(_vm._s(_vm.component.label))])
          : _vm._e(),
        _vm.values
          ? _c("div", { staticClass: "lead" }, [
              _c(
                "ul",
                { staticClass: "list-unstyled" },
                _vm._l(_vm.values, function (item) {
                  return _c("li", { key: item.value }, [
                    _vm._v(_vm._s(item.label)),
                  ])
                }),
                0
              ),
            ])
          : _c("div", { staticClass: "lead" }, [
              _c("span", { staticClass: "text" }, [_vm._v("-")]),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }